// Shared checklist constants + helpers (friendly answer types & fault severities).

export const ANSWER_TYPES = [
  { value: "yes_no", label: "Yes / No" },
  { value: "pass_fail", label: "Pass / Fail" },
  { value: "good_attention_fail", label: "Good / Attention / Fail" },
  { value: "number", label: "Number" },
  { value: "text", label: "Text" },
  { value: "photo", label: "Photo" },
  { value: "signature", label: "Signature" },
  { value: "date", label: "Date" },
  { value: "multiple_choice", label: "Multiple Choice" },
];

export const SEVERITIES = [
  { value: "", label: "No fault (informational)" },
  { value: "minor", label: "Minor" },
  { value: "major", label: "Major" },
  { value: "critical", label: "Critical — can stop use" },
];

export const METER_UNITS = [
  { value: "", label: "Not a reading" },
  { value: "miles", label: "Mileage — miles" },
  { value: "km", label: "Odometer — km" },
  { value: "hours", label: "Engine / operating hours" },
  { value: "cycles", label: "Cycles" },
];

export const typeLabel = (v) => (ANSWER_TYPES.find((t) => t.value === v) || {}).label || v;

export const sevBadgeCls = (s) =>
  s === "critical" ? "bg-red-600 text-white"
    : s === "major" ? "bg-orange-500 text-white"
      : s === "minor" ? "bg-amber-400 text-slate-900"
        : "bg-slate-200 text-slate-600";

export const sevLabel = (s) => (SEVERITIES.find((x) => x.value === (s || "")) || {}).label || "No fault";

export const statusBadgeCls = (st) =>
  st === "published" ? "bg-emerald-600 text-white"
    : st === "draft" ? "bg-blue-600 text-white"
      : "bg-slate-400 text-white"; // superseded

export const statusLabel = (st, isCurrent) =>
  st === "published" ? (isCurrent ? "Current" : "Published")
    : st === "draft" ? "Draft"
      : "Superseded";
